import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { AuthenticationResponse } from "pages/login/loginService";
import { BASE_BFF_WEB_URL } from "utilities/Constant";

export interface RecoverPasswordData {
  emailAddress: string;
  newPassword: string;
  recoveryCode: string;
}

export interface UpdatePasswordRequest {
  userId: string;
  password: string;
}


export const recoverApi = createApi({
  reducerPath: "recoverApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_BFF_WEB_URL }),
  endpoints: (build) => ({
    postReset: build.mutation<AuthenticationResponse, RecoverPasswordData>({
      query: (body: RecoverPasswordData) => ({
        url: "/Account/recoverpassword",
        method: "POST",
        body,
      }),
    }),
    PatchUpdatePassword: build.mutation<AuthenticationResponse, UpdatePasswordRequest>({
          query: (body: UpdatePasswordRequest) => ({
            url: "/Account/updatePassword",
            method: "PATCH",
            body,
          }),
        }),
  }),
});

export const { usePostResetMutation, usePatchUpdatePasswordMutation } = recoverApi;
